import React from "react";
import styled from "styled-components";
import { mobileScreenSize } from "../../../utils";
import { Typography } from "@commonsku/styles";
import { PageMode } from "./types";
import { OrderTemplate } from "../../../interfaces/OrderTemplate";
interface OrderTemplateBannerProps {
  orderTemplate: OrderTemplate;
  clientName: string;
  orderType: string;
  formNumber: string | number;
  mode: PageMode;
}
const OrderTemplateBannerDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  h2,
  h5 {
    margin-bottom: 0;
  }
  &&& {
    padding: 16px;
  }
`;

const OrderTemplateBannerLogo = styled.img`
  margin-left: 16px;
  &&& {
    width: 96px;
    height: 96px;
  }
`;

const OrderTemplateBannerContainer = styled.div<{
  backgroundUrl: string;
}>`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 150px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-image: url("${(props) => props.backgroundUrl}");

  @media (max-width: ${mobileScreenSize}px) {
    height: 300px;
    flex-direction: column;
  }

  &&& {
    margin-bottom: 32px;
  }
`;

const OrderTemplateBanner: React.FC<OrderTemplateBannerProps> = ({
  orderTemplate,
  clientName,
  orderType,
  formNumber,
  mode,
}) => {
  return (
    <OrderTemplateBannerContainer
      backgroundUrl={
        orderTemplate?.header?.file_name_headers || "/images/banner.png"
      }
    >
      <OrderTemplateBannerLogo
        src={
          orderTemplate?.avatar?.medium || "/images/favicons/favicon-96x96.png"
        }
        alt="Logo"
      />
      <OrderTemplateBannerDetails>
        <Typography.H2
          style={
            orderTemplate?.order_header_font_color_id
              ? {
                  color: orderTemplate.order_header_font_color_id,
                }
              : null
          }
        >
          {orderTemplate?.order_header_name}
        </Typography.H2>
        <Typography.H5
          style={
            orderTemplate?.order_header_font_color_id
              ? { color: orderTemplate.order_header_font_color_id }
              : null
          }
        >
          {mode === PageMode.CHANGE ? "Change Request" : "Approval"} for{" "}
          {clientName}
        </Typography.H5>
        <Typography.H5
          style={
            orderTemplate?.order_header_font_color_id
              ? {
                  color: orderTemplate.order_header_font_color_id,
                }
              : null
          }
        >
          {orderType} #{formNumber}
        </Typography.H5>
      </OrderTemplateBannerDetails>
    </OrderTemplateBannerContainer>
  );
};

export default OrderTemplateBanner;
